import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { PageSection } from './PageSection';
import { colors } from '../theme/tokens';

interface OnboardingPageProps {
    title?: string;
    steps?: string[];
    activeStep?: number;
    isMobile?: boolean;
}

/* Registration steps outside the account shell (/complete-profile/:step): title, optional stepper, one white card. */
export const OnboardingPage: React.FC<OnboardingPageProps> = ({ title = 'Complete your profile', steps, activeStep = 0, isMobile = false, children }) => (
    <Box sx={{ backgroundColor: '#F7F9FC', px: isMobile ? 1.5 : 3, py: isMobile ? 2 : 5 }}>
        <Box sx={{ maxWidth: 880, mx: 'auto', display: 'flex', flexDirection: 'column', gap: isMobile ? 2 : 3 }}>
            <Typography component="h1" sx={{ fontSize: isMobile ? 22 : 28, fontWeight: 600, color: colors.titleBlue }}>
                {title}
            </Typography>
            {steps && (
                <Stepper activeStep={activeStep} alternativeLabel={isMobile}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            )}
            <PageSection padding={isMobile ? 2 : 3}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>{children}</Box>
            </PageSection>
        </Box>
    </Box>
);

interface NextButtonProps {
    onClick: () => void;
    disabled?: boolean;
    busy?: boolean;
    label?: string;
}

/* The step's primary action, bottom right */
export const NextButton: React.FC<NextButtonProps> = ({ onClick, disabled, busy, label = 'Save & next' }) => (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" size="large" endIcon={<ArrowForwardIcon />} disabled={disabled || busy} onClick={onClick}>
            {busy ? 'Saving…' : label}
        </Button>
    </Box>
);
